import type { FilterSection } from "@/types/filterTypes";
    
export const usePhotoGalleryListFilterSections = (): FilterSection[] => {
  return [
    {
      key: "isKeyHighlight",
      label: "Is Key Highlight?",
      type: "boolean",
    },
    {
      key: "isMultimedia",
      label: "Is Multimedia?",
      type: "boolean",
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
